module.exports = __webpack_public_path__ + "static/media/logo_cuco.031a9247.png";